import { BaseError, ForbiddenError, NotFoundError, UnauthorizedError } from '../type';
import { isLatestAdminLogin } from './localStorage';
import { generalInternalServerErrorMessage } from './message';
import showToast from './showToast';
const errorHandlers = [
    apiUnauthorizedErrorHandler,
    apiForbiddenErrorHandler,
    apiNotFoundErrorHandler,
    apiInternalServerErrorHandler,
];
// エラーであれば true を返す
function apiUnauthorizedErrorHandler(error, _setErrorType) {
    if (error instanceof UnauthorizedError) {
        const path = encodeURIComponent(location.pathname + location.search);
        let actualIsAdmin = false;
        if (isLatestAdminLogin()) {
            actualIsAdmin = true;
        }
        const loginPath = actualIsAdmin ? `/admin/login?redirect_to=${path}` : `/login?redirect_to=${path}`;
        window.location.href = loginPath;
        return true;
    }
    return false;
}
// エラーであれば true を返す
function apiNotFoundErrorHandler(error, setErrorType) {
    if (error instanceof NotFoundError) {
        funcSetErrorType('Forbidden', setErrorType);
        return true;
    }
    return false;
}
function apiForbiddenErrorHandler(error, setErrorType) {
    if (error instanceof ForbiddenError) {
        funcSetErrorType('Forbidden', setErrorType);
        return true;
    }
    return false;
}
function funcSetErrorType(errorType, setErrorType) {
    try {
        setErrorType(errorType);
    }
    catch (e) {
        console.error('エラータイプの設定に失敗しました:', e);
        showToast.error(generalInternalServerErrorMessage);
    }
}
function apiInternalServerErrorHandler(error, _setErrorType) {
    if (error instanceof BaseError && error.errorCode === 'INTERNAL_SERVER_ERROR') {
        showToast.error(generalInternalServerErrorMessage);
        return true;
    }
    return false;
}
// エラーであれば true を返す
export function handleQueryError(error, setErrorType) {
    for (const handler of errorHandlers) {
        if (handler(error, setErrorType))
            return true;
    }
    return false;
}
//# sourceMappingURL=handleQueryError.js.map